<aside class="sidebar">
  <header>
    <app-dropdown-selection
      (selection)="teamSelectionDidChange($event)"
      [fallbackCover]="appConfig.TEAM_PLACEHOLDER"
      [options]="teams$ | async"
      [presentUsing]="firstContactEmail"
      [selectionFormControl]="teamField"
    ></app-dropdown-selection>
  </header>

  <div class="content">
    <div class="scroll-view">

      <app-draggable-action (click)="openJobDialog(action)"
                            *ngFor="let action of unacceptedActions"
                            [model]="action"
                            [subTitle]="ActionSubTitle.Location"
      >
        <div statusView>
          <app-status-contextual-menu>
            {{ statusFor(action) | translate }} <!-- Status to display -->
            <section menu-items>
              <button (click)="resend(action)"
                      mat-menu-item>{{ Localization.SendAgain | translate }}</button>
              <button (click)="unassign(action)"
                      mat-menu-item>{{ Localization.UnassignJob | translate }}</button>
            </section>
          </app-status-contextual-menu>
        </div>
      </app-draggable-action>
    </div>
  </div>

</aside>
<main [class.is-empty]="buildings?.length == 0">


  <figure *ngIf="buildings?.length == 0"
          class="empty-state m-auto">
    <svg class="sprite icon">
      <use xlink:href="#external-teams"></use>
    </svg>
    <figcaption>{{ Localization.EmptyInterventionTeamJobsViewMessage | translate }}</figcaption>
  </figure>

  <section *ngFor="let building of buildings"
           class="building-column">
    <header>
      <figure class="thumbnail">
        <img [src]="building.multimedium?.url || appConfig.BUILDING_PLACEHOLDER_URL"/>
      </figure>
      <h4 class="title">{{ building.label }}</h4>
      <h5 class="subtitle">{{ building.reference }}</h5>
      <span class="address">
        <i class="fa fa-map-marker"></i>
        {{ building.address | address }}
      </span>
      <span class="notification-count"
            role="status">{{ actionCountFor(building) }}</span>
    </header>

    <div class="content">
      <app-draggable-action (click)="openJobDialog(action)"
                            *ngFor="let action of actionsForBuilding(building)"
                            [model]="action"
                            [subTitle]="ActionSubTitle.Location"></app-draggable-action>
    </div>
  </section>
</main>

<div *ngIf="loading" class="page-spinner">
  <mdb-spinner spinnerColor="blue" spinnerType="big"></mdb-spinner>
</div>
